module.exports = __webpack_public_path__ + "img/outfield-picnic-pavilion-04.bbf40a5c.jpeg";